// Ana sayfa "Genel Anket Memnuniyet Oranı" çubuk grafiği rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'dashboard.surveySatisfaction';

export const surveySatisfactionGuide = (t: TFunction): GuideContent => ({
  layout: 'chart',
  title: t(`${G}.title`, 'Genel Anket Memnuniyet Oranı nasıl okunur?'),
  intro: t(`${G}.intro`, 'Bu grafik, müşteri memnuniyet anketlerindeki tüm cevapların dağılımını gösterir. Her çubuk bir cevap tipinin sayısını temsil eder; çubuğun üzerine gelince cevap sayısını ve tüm cevaplar içindeki oranını görürsünüz.'),
  chart: {
    kind: 'bar',
    legend: [
      { color: '#4CAF50', label: t(`${G}.l1.label`, 'Olumlu'), text: t(`${G}.l1.text`, 'Müşterilerin olumlu değerlendirmeleri (örn. "Evet", "Memnunum" vb.).') },
      { color: '#9E9E9E', label: t(`${G}.l2.label`, 'Nötr'), text: t(`${G}.l2.text`, 'Müşterilerin nötr değerlendirmeleri (örn. "Kısmen", "Orta" vb.).') },
      { color: '#F44336', label: t(`${G}.l3.label`, 'Olumsuz'), text: t(`${G}.l3.text`, 'Müşterilerin olumsuz değerlendirmeleri (örn. "Hayır", "Memnun değilim" vb.).') },
    ],
    note: t(`${G}.note`, 'Bu grafik sayesinde müşteri memnuniyeti konusunda genel bir bakış elde edebilir ve hangi alanlarda iyileştirme yapmanız gerektiğini belirleyebilirsiniz.'),
  },
});
